/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ColumnSettingsViewMode {
  Basic = 0,
  Advanced = 1,
  Custom = 2,
  Detailed = 3,
}
